<template>
  <div
    class="upsell-hero flex w-full flex-col items-center gap-4 text-center"
    data-testid="upsell-hero"
  >
    <UpsellGateBadge dark :text="badgeText" />
    <OwnType
      class="upsell-hero__title"
      :text="title"
      variant="heading-regular"
      align="center"
    />
    <img
      class="upsell-hero__phone"
      :src="heroPhones"
      alt=""
      data-testid="upsell-hero-phone"
    />
    <OwnType
      v-if="description"
      class="upsell-hero__description"
      :text="description"
      variant="paragraph-regular"
      color="secondary"
      align="center"
    />
  </div>
</template>

<script lang="ts" setup>
import { OwnType } from '@/ui/OwnType'

import heroPhones from '../assets/hero-phone.png'

import UpsellGateBadge from './UpsellGateBadge.vue'

withDefaults(
  defineProps<{
    badgeText?: string
    description?: string
    title: string
  }>(),
  {
    badgeText: undefined,
    description: undefined,
  }
)
</script>

<style lang="scss" scoped>
.upsell-hero {
  &__title {
    max-width: 520px;
    font-weight: 600;
  }

  &__phone {
    width: 100%;
    max-width: 200px;
  }

  &__description {
    max-width: 560px;
  }
}
</style>
